import React, {useEffect, useMemo} from 'react';
import {useParams} from 'react-router-dom';
import {shallowEqual, useDispatch, useSelector} from 'react-redux';
import * as actions from './_redux/userDetailsActions';
import {useUserDetailsUIContext} from './UserDetailsUIContext';
import {mapUserDetails} from './utils/mapUserDetails';
import {DetailsOverview} from './pages/DetailsOverview';
import {PersonalInfo} from './components/PersonalInfo';
import styles from './styles.module.scss';

export function DetailsCard() {
  const {userId} = useParams();
  const dispatch = useDispatch();
  const userDetails = useSelector((state) => state.userDetails.user, shallowEqual);
  const userDataHistory = useSelector((state) => state.userDetails.userDataHistory, shallowEqual);
  const {historyPoint, queryParams, setQueryParams} = useUserDetailsUIContext();

  const getCurrentUserDetails = () => {
    if (historyPoint) {
      const {additional_data, ...rest} = userDetails;
      const newAdditionalData = userDataHistory && userDataHistory.history
        .filter(item => item.createdAt === historyPoint?.value)
        .filter(Boolean);

      return {
        additional_data: newAdditionalData.length > 0 ? newAdditionalData : additional_data,
        ...rest
      };
    } else return userDetails
  };

  const user = mapUserDetails(getCurrentUserDetails());
  const {personalInfo, ...restData} = user;

  const userDetailsUIProps = useMemo(() => {
    return {queryParams, setQueryParams};
  }, [queryParams, setQueryParams]);

  useEffect(() => {
    Promise.resolve()
      .then(() => {
        userDetailsUIProps.setQueryParams({userId});
      })
      .then(() => {
        dispatch(actions.fetchUser({userId}));
        dispatch(actions.getUserAdditionalDataHistory({userId}));
      })
  }, []);

  return (
    <div className={styles.userDetailsContainer}>
      {user && (
        <div className={styles.personalInfoContainer}>
          <div className="card card-custom card-stretch">
            <PersonalInfo data={personalInfo}/>
          </div>
        </div>
      )}
      <div className={styles.detailsOverviewContainer}>
        <DetailsOverview {...restData} />
      </div>
    </div>
  );
}
